import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

import { withDefaults, watch, onMounted, ref } from 'vue';
import { AtomCheckBox, AtomRadio } from '../atoms';
import { MoleculeFilters } from '../molecules';
interface IProps {
    items: any[];
    type: string;
    name?: string;
    filters?: boolean;
    card?: boolean;
    clear?: any;
    clicked_id?: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeListRadioCheckbox',
  props: {
    items: {},
    type: {},
    name: {},
    filters: { type: Boolean, default: false },
    card: { type: Boolean, default: false },
    clear: {},
    clicked_id: {}
  },
  emits: ['handleSelect'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const list = ref<any[]>([]);

function handlechecked(item, index){

    if(item.checked)
    handleLineClick(index);
}
function handleLineClick(id)
{
    const element = document.getElementById(id);

    if(element)
    {
        element.checked = true;
        
        emit("handleSelect", { event: [list.value[id]], id: id });
    }
}

onMounted(() => {
    list.value = props.items;
})
watch(
    () => list.value,
    () => {
        // emit("handleSelect", list.value.filter(f => f.checked))
    },
    { deep: true }
)
watch(
    () => props.items,
    () => {
        list.value = props.items;
    },
    { deep: true }
)
watch(
    () => props.clear,
    () => {
        if(props.clear)
        {
            const element = document.getElementById(props.clicked_id);

            if(element)
            {
                element.checked = false;
            }

            list.value.map(x => {
                x.checked = false;
            });
        }
    }
)

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.card ? `border container-table bg-white my-5`:''])
  }, [
    (props.filters)
      ? (_openBlock(), _createBlock(_unref(MoleculeFilters), { key: 0 }, {
          areaFilter: _withCtx(() => [
            _renderSlot(_ctx.$slots, "areaFilter")
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_list, {
      style: {"max-height":"18em"},
      class: "overflow-y-auto"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, idx) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: idx + 'it'
          }, [
            _createVNode(_component_v_list_item, { class: "px-8" }, {
              prepend: _withCtx(() => [
                (_ctx.type == 'checkbox')
                  ? (_openBlock(), _createBlock(_unref(AtomCheckBox), {
                      key: 0,
                      modelValue: item.checked,
                      "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                      checked: item.checked,
                      onChange: ($event: any) => (handlechecked(item,idx))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "checked", "onChange"]))
                  : _createCommentVNode("", true),
                (_ctx.type == 'radio')
                  ? (_openBlock(), _createBlock(_unref(AtomRadio), {
                      key: 1,
                      modelValue: item.checked,
                      "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                      checked: item.checked,
                      id: `${idx}`,
                      onChange: ($event: any) => (handlechecked(item,idx)),
                      name: props.name ?? "list"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "checked", "id", "onChange", "name"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, {
                  onClick: ($event: any) => (handleLineClick(idx))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024),
            (idx !== list.value.length - 1)
              ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    })
  ], 2))
}
}

})